import {
  type FlowFilterListBlockConfig,
  FlowFilterListBlockConfigSchema,
  FlowLimitReturnType,
} from 'flow-schema';

import { FilterBlockFormFields } from './FormFields.tsx';
import { FilterBlockDocumentationMarkdown } from './documentation.ts';
import type { BlockConfigProps } from '../../types.ts';

export const filterListConfig: BlockConfigProps<FlowFilterListBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'filterList',
  defaultConfig: {
    originalList: '',
    filterConfig: undefined,
    sortConfig: undefined,
    limitConfig: {
      returnType: FlowLimitReturnType.List,
      offset: 0,
    },
  },
  configFields: {
    schema: FlowFilterListBlockConfigSchema,
    FormFields: FilterBlockFormFields,
  },
  documentationMarkdown: FilterBlockDocumentationMarkdown,
};
